import React, { useState, useEffect } from "react"
import { fetch_get, fetch_post } from "../../../utils/fetch"
import { useAuth0 } from "@auth0/auth0-react"

export default function ProjectCiStatus(props) {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0()
  const [statusObj, setStatusObj] = useState({})
  var [loadStatus, setLoadStatus] = useState({ loading: false, error: false, errorMessage: null })

  const check_status = () => {
    setLoadStatus({ loading: true, error: false, errorMessage: null })

    console.log("inside check status")
    var urlparams = props.urlparams
    // setCiEnableEl(null)
    getAccessTokenSilently()
      .then(accessToken =>
        fetch_get(`projects/${props.project.projectSlug}/ci/status${urlparams}`, accessToken)
      )
      .then(response => {
        console.log(response)
        setStatusObj(response)
        setLoadStatus({ loading: false, error: false, errorMessage: null })
      })
      .catch(error => {
        setLoadStatus({ loading: false, error: true, errorMessage: `${error}` })
        console.log(error)
      })
  }

  useEffect(() => {
    if (props.project === undefined) return
    console.log("ci sttaus fire")
    check_status()
  }, [props.project])

  const get_refresh_button = () => {
    return (
      <button type="button" onClick={() => check_status()} className="btn btn-sm btn-info">
        Refresh
      </button>
    )
  }

  return (
    <>
      {loadStatus.loading && !loadStatus.error && (
        <>
          <div className="spinner-grow spinner-grow-sm" role="status"></div> Checking for status...
        </>
      )}
      {!loadStatus.loading && !loadStatus.error && (
        <>
          {statusObj.enabled && (
            <>
              {statusObj.status === "pending" && (
                <>
                  <div className="alert alert-primary" role="alert">
                    <div className="spinner-grow spinner-grow-sm" role="status"></div>&nbsp; CI
                    enablement is currently waiting to be processed. Please check back later.&nbsp;
                    {get_refresh_button()}
                  </div>
                </>
              )}
              {/* {statusObj.status === "completed" && (
                <>
                  <div className="alert alert-success" role="alert">
                    Your request is completed sucessfully
                  </div>
                </>
              )} */}
              {statusObj.status !== "pending" && statusObj.status !== "completed" && (
                <>
                  <div className="alert alert-primary" role="alert">
                    <div className="spinner-grow spinner-grow-sm" role="status"></div>&nbsp; CI
                    enablement is currently in progress. Please check back later. &nbsp;
                    {get_refresh_button()}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
